import React, { useState, useRef, useEffect } from 'react';
import Web3 from 'web3';
import axios from 'axios';
import QrScanner from 'react-qr-scanner';
import tickImage from '../../img/tick.png'
import crossImage from '../../img/cross.png';
import { useParams } from 'react-router-dom';
import mainbg from '../../img/leaderbrd_bckgrnd.png';
import bg from '../../img/leaderbrd_blue.png';

import { blockchainURL, contractAddress, username, password, contractAbi } from '../../contracts/SupplyChainContract';

const BatchDetailsPage = () => {
  const { id } = useParams();
  const [batchId, setBatchId] = useState(id || '');
  const [batchDetails, setBatchDetails] = useState(null);
  const [errorMessage, setErrorMessage]  = useState('');
  const [cameraOn, setCameraOn] = useState(true); 
  const web3 = new Web3(new Web3.providers.HttpProvider(blockchainURL));
  const contract = new web3.eth.Contract(contractAbi, contractAddress);
  const [qrData, setQrData] = useState('');
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const qrRef = useRef(null);

  useEffect(() => {
    if (batchId) {
      handleSearchByBatchId();
    }
  }, [batchId]);

  const handleScan = (data) => {
    if (data && data.text) {
      const url = new URL(data.text);
      if (url.hostname === 'fypshowcase.vercel.app' && url.pathname.startsWith('/batch-details/')) {
        const batchId = url.pathname.split('/').pop();
        setQrData(batchId);
        setBatchId(batchId);
      } else {
        setQrData(data.text);
        setBatchId(data.text);
      }
      setCameraOn(false);
      setIsCameraOpen(false);
    }
  };
  
  const handleError = (error) => {
    console.error('Error scanning QR code:', error);
  };

  const toggleCamera = () => {
    if (!isCameraOpen && qrRef.current) {
      qrRef.current.stop();
    }
    setCameraOn(!cameraOn);
    setIsCameraOpen(!isCameraOpen);
  };

  const handleInputChange = (event) => {
    setBatchId(event.target.value);
  };

  const handleSearchByBatchId = async () => {
    setErrorMessage('');

    try {
      const basicAuth = 'Basic ' + window.btoa(`${username}:${password}`);
    
      // Fetch Farmer VC
      const farmerPayload = {
        jsonrpc: '2.0',
        method: 'eth_call',
        params: [{
          to: contractAddress,
          data: contract.methods.farmerVCs(batchId).encodeABI()
        }, 'latest'],
        id: new Date().getTime()
      };
    
      const farmerResponse = await axios.post(blockchainURL, farmerPayload, {
        headers: { 'Authorization': basicAuth }
      });
  
      // Fetch Inspector VC
      const inspectorPayload = {
        jsonrpc: '2.0',
        method: 'eth_call',
        params: [{
          to: contractAddress,
          data: contract.methods.inspectorVCs(batchId).encodeABI()
        }, 'latest'],
        id: new Date().getTime()
      };
  
      const inspectorResponse = await axios.post(blockchainURL, inspectorPayload, {
        headers: { 'Authorization': basicAuth }
      });
  
      // Fetch Distributor VC
      const distributorPayload = {
        jsonrpc: '2.0',
        method: 'eth_call',
        params: [{
          to: contractAddress,
          data: contract.methods.distributorVCs(batchId).encodeABI()
        }, 'latest'],
        id: new Date().getTime()
      };
  
      const distributorResponse = await axios.post(blockchainURL, distributorPayload, {
        headers: { 'Authorization': basicAuth }
      });
  
      // Fetch Retailer VC
      const retailerPayload = {
        jsonrpc: '2.0',
        method: 'eth_call',
        params: [{
          to: contractAddress,
          data: contract.methods.retailerVCs(batchId).encodeABI()
        }, 'latest'],
        id: new Date().getTime()
      };
  
      const retailerResponse = await axios.post(blockchainURL, retailerPayload, {
        headers: { 'Authorization': basicAuth }
      });
  
      if (farmerResponse.data.result && inspectorResponse.data.result && distributorResponse.data.result && retailerResponse.data.result) {
        const farmerData = web3.eth.abi.decodeParameters([
          {
            "internalType": "uint256",
            "name": "batchID",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "dateOfProduction",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "quantity",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "expiryDate",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "gradingResults",
            "type": "string"
          },
          {
            "internalType": "address",
            "name": "farmerAddress",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "countryOfOrigin",
            "type": "string"
          }
        ], farmerResponse.data.result);

              // Check if the farmer's timestamp is 0
      if (farmerData.timestamp === '0') {
        setErrorMessage('Batch ID not found or registered. Please check the batch ID and try again.');
        setBatchDetails(null); // Clear batch details if not registered
        return; // Exit the function
      }
  
        const inspectorData = web3.eth.abi.decodeParameters([
          {
            "internalType": "uint256",
            "name": "batchID",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "inspectorCheck",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "inspectorAddress",
            "type": "address"
          },
          {
            "internalType": "string",
            "name": "remark",
            "type": "string"
          },
          {
            "internalType": "bool",
            "name": "dangerCheck",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          }
        ], inspectorResponse.data.result);
  
        const distributorData = web3.eth.abi.decodeParameters([
          {
            "internalType": "uint256",
            "name": "batchID",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "distributorAddress",
            "type": "address"
          },
          {
            "internalType": "bool",
            "name": "acceptance",
            "type": "bool"
          },
          {
            "internalType": "string",
            "name": "remark",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          }
        ], distributorResponse.data.result);
  
        const retailerData = web3.eth.abi.decodeParameters([
          {
            "internalType": "uint256",
            "name": "batchID",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "stockingInfo",
            "type": "string"
          },
          {
            "internalType": "address",
            "name": "retailerAddress",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          }
        ], retailerResponse.data.result);
  
        farmerData.timestamp = convertEpochToDateTime(farmerData.timestamp);
        inspectorData.timestamp = convertEpochToDateTime(inspectorData.timestamp);
        retailerData.timestamp = convertEpochToDateTime(retailerData.timestamp);
        console.log("Raw distributor timestamp from blockchain:", distributorData.timestamp);

        setBatchDetails({
          farmerDetails: {
            ...farmerData,
          },
          inspectorDetails: {
            ...inspectorData,
            updateTimestamp: convertEpochToDateTime(new Date().getTime()),
          },
          distributorDetails: {
            ...distributorData,
            timestamp: convertEpochToDateTime(distributorData.timestamp),
          },
          retailerDetails: retailerData,
        });
      } else {
        throw new Error('No result from Kaleido blockchain');
      }
    } catch (error) {
      console.error('Error fetching batch details:', error);
      setErrorMessage('Error fetching batch details. Please check the batch ID and try again.');
    }
  };
  
  function convertEpochToDateTime(epoch) {
    const date = new Date(epoch * 1000);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen" style={{ backgroundImage: `url(${mainbg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
        <div className="rounded-3xl p-4" style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}}>
        <p className="text-center font-semibold text-white" style={{fontSize: '25px'}}>
          Enter the batch ID 
        </p>  
        <p className="text-center font-semibold underline text-white" style={{fontSize: '25px'}}> OR </p>
        <p className=" text-center font-semibold mb-4 text-white" style={{fontSize: '25px'}}>Press Scanner to scan the QR code on the beef packaging</p>
        {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}
    
        <div className="mb-2 flex items-center justify-center">
          <input
            type="text"
            value={batchId || qrData}  
            placeholder="Enter Batch ID"
            onChange={handleInputChange}
            className="border p-2 mr-2 w-48 shadow-lg"
          />
          <button
            onClick={handleSearchByBatchId}
            className="bg-blue-500 text-white px-4 py-2 rounded mr-2 shadow-lg"
          >
            Search
          </button>

          {/* Camera Toggle Button */}
          <button
            onClick={toggleCamera}
            className={`bg-${isCameraOpen ? 'red' : 'blue'}-500 text-white px-4 py-2 rounded shadow-lg`}
          >
            {isCameraOpen ? 'Turn Off' : 'Scanner'}
          </button>
        </div>
        

        {/* Add QR Scanner */}
        <div className=" flex items-center justify-center">
        {isCameraOpen && (
          <QrScanner
            onScan={handleScan}
            onError={handleError}
            ref={qrRef}
            style={{ width: '100%', maxWidth: '400px' }}
            constraints={{ video: { facingMode: 'environment' } }}
          />
          )}
        </div>
        

        {batchDetails && (
          <div className="flex flex-col items-center" >
              {/* Consumable Alert */}
              {!batchDetails.inspectorDetails.dangerCheck && batchDetails.inspectorDetails.inspectorCheck && (
                <div className=" p-3 bg-green-200 border border-green-400 text-green-800 rounded w-96 text-center mb-1">
                  <strong>SAFETY</strong>
                  <p>Beef are consumable!</p>
                </div>
              )}
          
              {/* Danger Alert */}
              {batchDetails.inspectorDetails && batchDetails.inspectorDetails.dangerCheck && (
                <div className=" p-3 bg-red-200 border border-red-400 text-red-800 rounded w-96 text-center mb-1">
                  <strong>DANGER</strong>
                  <p>DO NOT CONSUME THE BEEF.</p>
                  <p>VISIT A DOCTOR IMMEDIATELY IF CONSUMED.</p>
                  <div className="mt-2 text-red-800">
                    <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-800 rounded text-center mb-4 w-full">
                      <strong>Reason:</strong> 
                      <p>{batchDetails.inspectorDetails.remark}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Farmer Details */}
              {batchDetails.farmerDetails && (
                <div className="flex mb-4 p-6 border rounded bg-blue-50 text-left w-96">
                  <div className="w-full">

                    <h3 className="text-xl font-semibold mb-4 text-center">Beef Details</h3>
                    <table className="w-full">
                      <tbody>
                        <tr>
                          <td>Grading Results:</td>
                          <td>{batchDetails.farmerDetails.gradingResults}</td>
                        </tr>
                        <tr>
                          <td>Country Of Origin:</td>
                          <td>{batchDetails.farmerDetails.countryOfOrigin}</td>
                        </tr>
                        <tr>
                          <td>Date of Production:</td>
                          <td>{convertEpochToDateTime(batchDetails.farmerDetails.dateOfProduction)}</td>
                        </tr>
                        <tr>
                          <td>Expiry Date:</td>
                          <td>{convertEpochToDateTime(batchDetails.farmerDetails.expiryDate)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
          )}
        <div className='flex flex-wrap gap-2 justify-center'>
          {batchDetails.farmerDetails && !batchDetails.inspectorDetails.dangerCheck && (
            <div className={`flex mb-1 p-6 border rounded ${batchDetails.farmerDetails.timestamp ? 'bg-green-50' : 'bg-red-100'} text-left w-96`}>
              <div className="w-full text-center">
                <h3 className={`text-xl font-semibold mb-4 ${batchDetails.farmerDetails.timestamp ? 'text-green-800' : 'text-red-600'}`}>
                  Meat Processor
                </h3>
                <img
                  src={batchDetails.farmerDetails.timestamp ? tickImage : crossImage}
                  alt={batchDetails.farmerDetails.timestamp ? 'Accepted' : 'Not Checked'}
                  className="mx-auto w-12 h-12 mb-4"
                />
                <div className="mt-2">
                  <p className="text-sm font-semibold text-gray-800">Time: {batchDetails.farmerDetails.timestamp}</p>
                </div>
              </div>
            </div>
          )}

            {/* Inspector Details */}
            {!batchDetails.inspectorDetails.dangerCheck && batchDetails.inspectorDetails && (
              <div className={`flex mb-1 p-6 border rounded ${batchDetails.inspectorDetails.inspectorCheck && !batchDetails.inspectorDetails.dangerCheck ? 'bg-green-50' : 'bg-red-100'} text-left w-96`}>
                <div className="w-full text-center">
                  <h3 className={`text-xl font-semibold mb-4 ${batchDetails.inspectorDetails.inspectorCheck && !batchDetails.inspectorDetails.dangerCheck ? 'text-green-800' : 'text-red-600'}`}>
                    Inspector
                  </h3>
                  <img
                    src={batchDetails.inspectorDetails.inspectorCheck && !batchDetails.inspectorDetails.dangerCheck ? tickImage : crossImage}
                    alt={batchDetails.inspectorDetails.inspectorCheck && !batchDetails.inspectorDetails.dangerCheck ? 'Passed' : 'Failed'}
                    className="mx-auto w-12 h-12 mb-4"
                  />
                  <div className="mt-2">
                    <p className="text-sm font-semibold text-gray-800">Time: {batchDetails.inspectorDetails.timestamp}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Distributor Details */}
            {batchDetails.distributorDetails && !batchDetails.inspectorDetails.dangerCheck && (
              <div className={`flex mb-1 p-6 border rounded ${batchDetails.inspectorDetails.dangerCheck ? 'bg-red-100' : (batchDetails.distributorDetails.acceptance ? 'bg-green-50' : 'bg-red-100')} text-left w-96`}>
                <div className="w-full text-center">
                  <h3 className={`text-xl font-semibold mb-4 ${batchDetails.distributorDetails.acceptance && !batchDetails.inspectorDetails.dangerCheck ? 'text-green-800' : 'text-red-600'}`}>
                    Distributor
                  </h3>
                  <img
                    src={batchDetails.distributorDetails.acceptance && !batchDetails.inspectorDetails.dangerCheck ? tickImage : crossImage}
                    alt={batchDetails.distributorDetails.acceptance && !batchDetails.inspectorDetails.dangerCheck ? 'Accepted' : 'Not Accepted'}
                    className="mx-auto w-12 h-12 mb-4"
                  />
                  <div className="mt-2">
                    <p className="text-sm font-semibold text-gray-800">Time: {batchDetails.distributorDetails.timestamp}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Retailer Details */}
            {batchDetails.retailerDetails && !batchDetails.inspectorDetails.dangerCheck && (
              <div className={`flex mb-1 p-6 border rounded ${batchDetails.inspectorDetails.dangerCheck ? 'bg-red-100' : (batchDetails.retailerDetails.stockingInfo !== '' ? 'bg-green-50' : 'bg-red-100')} text-left w-96`}>
                <div className="w-full text-center">
                  <h3 className={`text-xl font-semibold mb-4 ${batchDetails.retailerDetails.stockingInfo !== '' && !batchDetails.inspectorDetails.dangerCheck ? 'text-green-800' : 'text-red-600'}`}>
                    Retailer
                  </h3>
                  <img
                    src={batchDetails.retailerDetails.stockingInfo !== '' && !batchDetails.inspectorDetails.dangerCheck ? tickImage : crossImage}
                    alt={batchDetails.retailerDetails.stockingInfo !== '' && !batchDetails.inspectorDetails.dangerCheck ? 'Accepted' : 'Not Checked'}
                    className="mx-auto w-12 h-12 mb-4"
                  />
                  <div className="mt-2">
                    <p className="text-sm font-semibold text-gray-800">Time: {batchDetails.retailerDetails.timestamp}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          

        </div>
      )}
    </div>
    </div>
  );
};

export default BatchDetailsPage;